/**
 * This is the termscond service.
 * @memberOf termscond Module
 * @namespace termscond Service
 */

/**
 * @name termscondService
 * @desc Create the service.
 * @param $q
 * @param termscondDataService
 * @memberOf termscond Module.termscond Service
 * @ngInject
 */
function termscondFactory($q, termscondDataService) {
    // Create the service.
    var service = {};
    return service;
}

export default termscondFactory;



// WEBPACK FOOTER //
// ./src/login/termscond/termscond.service.js